module.exports = __webpack_public_path__ + "static/ici-paris-couverture-d3fced3e4aa0410172495f3a759fe262.jpg";